// extracted by mini-css-extract-plugin
export default {"error":"Login_error__Dw4G+","container":"Login_container__FtxIa","box":"Login_box__MfjWX","form":"Login_form__moJeK"};